import { FaFlask } from "react-icons/fa";
import ServiceRow from "./ServiceRow";

export default function Laboratorija() {
  return (
    <ServiceRow
      id="laboratorija"
      icon={<FaFlask />}
      title="Лабораториски анализи"
    >
      <p className="intro-text">
        Нудиме брзи, точни и сигурни лабораториски анализи со современа опрема и стручен тим.
      </p>

      <div className="mini-grid">

        <div className="mini-card">
          <h4>🧪 Основни анализи</h4>
          <ul className="service-list">
            <li><span className="check">✓</span> Крвна слика</li>
            <li><span className="check">✓</span> Урина</li>
            <li><span className="check">✓</span> Шеќер во крв</li>
          </ul>
        </div>

        <div className="mini-card">
          <h4>📊 Биохемија</h4>
          <ul className="service-list">
            <li><span className="check">✓</span> Холестерол</li>
            <li><span className="check">✓</span> Триглицериди</li>
            <li><span className="check">✓</span> Ензими</li>
          </ul>
        </div>

        <div className="mini-card">
          <h4>🧬 Напредни анализи</h4>
          <ul className="service-list">
            <li><span className="check">✓</span> Хормони</li>
            <li><span className="check">✓</span> Витамини</li>
            <li><span className="check">✓</span> Имунолошки тестови</li>
          </ul>
        </div>

        <div className="mini-card">
          <h4>⚡ Брзина</h4>
          <ul className="service-list">
            <li><span className="check">✓</span> Брзи резултати</li>
            <li><span className="check">✓</span> Точни анализи</li>
            <li><span className="check">✓</span> Современа опрема</li>
          </ul>
        </div>

      </div>

      <div className="bottom-box">
        <h4>Зошто да изберете нас?</h4>
        <div className="pill-list">
          <span>Брзи резултати</span>
          <span>Висока точност</span>
          <span>Стручен тим</span>
          <span>Модерна технологија</span>
        </div>
      </div>

    </ServiceRow>
  );
}